import extractErrorMessage from '../../../shared/utils/extractErrorMessage';
import { authClient } from '../../../shared/api/client';

const isOkStatus = (status) => status >= 200 && status < 300;

// Sacuvane mesecne aktivnosti grupisane po pacijentu.
// Bek vraca aktivnosti sa statusom "saved" iz aktuelnih i proslih terapija.
export const fetchSavedTherapies = async ({
  page = 1,
  limit = 10,
  userSearch = null,
  lboSearch = null,
  bzkSearch = null,
  medications = [],
  medicationMatch = null,
  pickupMethod = null,
  startDate = null,
  endDate = null,
}) => {
  try {
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('limit', String(limit));

    if (userSearch) params.set('userSearch', userSearch);
    if (lboSearch) params.set('lboSearch', lboSearch);
    if (bzkSearch) params.set('bzkSearch', bzkSearch);
    // Svaki izabrani lek ide kao zaseban `medications` parametar - nazivi
    // mogu da sadrze zarez, pa se ne spajaju u jedan string.
    (Array.isArray(medications) ? medications : [])
      .filter(Boolean)
      .forEach((name) => params.append('medications', name));
    // Nacin poklapanja lekova ('any' | 'exact') - salje se samo uz izabrane lekove.
    if (medicationMatch && medications?.length) {
      params.set('medicationMatch', medicationMatch);
    }
    if (startDate) params.set('startDate', startDate);
    if (endDate) params.set('endDate', endDate);

    if (pickupMethod) {
      const pickupMethods = (
        Array.isArray(pickupMethod) ? pickupMethod : [pickupMethod]
      ).filter(Boolean);

      if (pickupMethods.length) {
        params.set('pickupMethod', pickupMethods.join(','));
      }
    }

    const response = await authClient.get(
      `/therapies/saved?${params.toString()}`
    );

    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri dobavljanju sacuvanih terapija.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};
